import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import Grid from '@material-ui/core/Grid';

import { Card } from 'core/components/card';
import { Label } from 'core/components/label';
import Field from 'core/components/form/form.v2';
import ValueField from 'core/components/value-field';
import useSession from 'core/hooks/use-session';

import useStyles from './change-of-coverage-card.styles';

// #34275: Underwriter-only "Change of Coverage" free-type box. Mirrors the Policy Restrictions box
// (permission model + placement), but drives a different downstream form: any text entered here
// triggers generation of the per-brand Change of Coverage notice, inserted into the policy packet
// immediately after the welcome page and before the dec.
const MAX_LENGTH = 1000;
const FIELD_LABEL = 'Change of Coverage description (optional)';
const PLACEHOLDER =
  'Describe the change of coverage. Any text here prints a Change of Coverage notice in the policy packet.';

const ChangeOfCoverageCard = ({ variant }) => {
  const classes = useStyles({ variant });
  const isModal = variant === 'modal';
  const { canApproveUWReview } = useSession();
  const { values } = useFormikContext();
  const changeOfCoverage = values?.changeOfCoverage;

  if (!canApproveUWReview && !changeOfCoverage) {
    return null;
  }

  return (
    <Grid container className={classes.sectionContainer}>
      {!isModal && (
        <Label type="subtitle1" className={classes.sectionHeader}>
          Change of Coverage
        </Label>
      )}
      <Card className={classes.card}>
        {isModal && <Label className={classes.cardTitle}>Change of Coverage</Label>}
        {canApproveUWReview ? (
          <Field
            id="changeOfCoverage"
            name="changeOfCoverage"
            type="textarea"
            mode="light"
            label={FIELD_LABEL}
            placeholder={PLACEHOLDER}
            inputProps={{ maxLength: MAX_LENGTH }}
            rows={isModal ? 2 : undefined}
            className={classes.textareaField}
          />
        ) : (
          <ValueField label={FIELD_LABEL} value={changeOfCoverage} />
        )}
      </Card>
    </Grid>
  );
};

ChangeOfCoverageCard.propTypes = {
  variant: PropTypes.string
};

ChangeOfCoverageCard.defaultProps = {
  variant: undefined
};

export default ChangeOfCoverageCard;
